import {
  useMutation,
  useQuery,
  type UseMutationResult,
  type UseQueryResult,
} from '@tanstack/react-query';
import type {
  AddTicketPortalTimeEntryInput,
  AddTicketPortalTimeEntryResult,
  TicketPortalView,
  TicketPortalWeekStatus,
} from '@catalyst-psa/shared';

import { publicApi } from '../project-portal/publicApi.js';

export function useTicketPortalView(token: string): UseQueryResult<TicketPortalView> {
  return useQuery({
    queryKey: ['public-ticket-portal', token],
    enabled: Boolean(token),
    retry: false,
    queryFn: () => publicApi.get<TicketPortalView>(`/public/tickets/${token}`),
  });
}

export function useTicketPortalWeekStatus(
  token: string,
  weekStart: string,
  enabled: boolean,
): UseQueryResult<TicketPortalWeekStatus> {
  return useQuery({
    queryKey: ['public-ticket-portal', token, 'week-status', weekStart],
    enabled: enabled && Boolean(token) && Boolean(weekStart),
    retry: false,
    queryFn: () =>
      publicApi.get<TicketPortalWeekStatus>(
        `/public/tickets/${token}/week-status?weekStart=${weekStart}`,
      ),
  });
}

export function useAddTicketPortalTimeEntry(
  token: string,
): UseMutationResult<AddTicketPortalTimeEntryResult, unknown, AddTicketPortalTimeEntryInput> {
  return useMutation({
    mutationFn: (input: AddTicketPortalTimeEntryInput) =>
      publicApi.post<AddTicketPortalTimeEntryResult>(
        `/public/tickets/${token}/time-entries`,
        input,
      ),
  });
}
